import { zodContract } from '@farfetched/zod';
import { createQuery } from '../clients';
import { settingsSchema } from '../types';

export const getSettingsQuery = createQuery({
	request: {
		method: 'GET',
		url: '/rounds',
	},
	response: {
		contract: zodContract(settingsSchema),
	},
});
